import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import arePropsEqual from '../../../helpers/arePropsEqual';
import { classnames } from '../../../helpers/classnames';
import { bem } from '../../../helpers/styles';
import { omit } from '../../../helpers/omit';

import styles from './Switch.css';

function SwitchComponent({
  type = 'checkbox',
  name,
  id,
  checked,
  className,
  style,
  onChange = () => null,
  onBlur = () => null,
  ...restProps
}) {
  useEffect(() => {
    onBlur();
  }, [checked]);

  const props = {
    type,
    name,
    id,
    checked,
    className: classnames([bem(styles, 'Switch'), className]),
    style,
    onChange: ({ target: { checked } }) => onChange(checked),
    onBlur,
  };

  return <input {...props} {...omit(restProps, 'label', 'error', 'block')} />;
}

SwitchComponent.propTypes = {
  type: PropTypes.oneOf(['checkbox', 'radio']),
  label: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  checked: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

const Switch = memo(SwitchComponent, (oldProps, newProps) => {
  return arePropsEqual(oldProps, newProps);
});

export default Switch;
